import { getTravellerFormSchemaRequestKey } from './request/travellerSchema'

const getCheckoutTravellerSchema = (state: App.State) => state.checkout.schemaData[getTravellerFormSchemaRequestKey(state)]

export default getCheckoutTravellerSchema
